export default [
    { route: '/',       label: 'Home'   },
    { route: '/search', label: 'Search' },
    { route: '/grail',  label: 'Grail'  },
];